export const generateAddedValueFormName = (index: number) => {
  return `addedProduct${index}`;
};

export const generatePreAddedValueFormName = (index: number) => {
  return `preAddedProduct${index}`;
};
